<div class=" min-h-screen space-y-8">

  <!-- ============================= -->
  <!-- PROPOSED FACILITY -->
  <!-- ============================= -->
  <div class="bg-white rounded-xl shadow p-6">

    <div class="flex justify-between items-center mb-4">
      <h2 class="text-lg font-semibold text-indigo-900">{{ 'CREDIT_TERMS.PROPOSED_FACILITY' | translate }}</h2>

      <button
        (click)="onAddFacility()"
        class="bg-indigo-600 text-white px-4 py-2 rounded-lg flex items-center gap-2"
      >
        {{ 'CREDIT_TERMS.ADD_NEW' | translate }}
      </button>
    </div>

    <app-table
      [columns]="facilityColumns"
      [data]="facilityData"
      [actions]="tableActions"
      [selectable]="true"
    ></app-table>

  </div>


  <!-- ============================= -->
  <!-- USAGE PLAN -->
  <!-- ============================= -->
  <div class="bg-white rounded-xl shadow p-6">

    <div class="flex justify-between items-center mb-4">
      <h2 class="text-lg font-semibold text-indigo-900">
        {{ 'CREDIT_TERMS.USAGE_PLAN' | translate }}
      </h2>

      <button
        (click)="onAddUsage()"
        class="bg-indigo-600 text-white px-4 py-2 rounded-lg flex items-center gap-2"
      >
        {{ 'CREDIT_TERMS.ADD_NEW' | translate }}
      </button>
    </div>

    <app-table
      [columns]="usageColumns"
      [data]="usageData"
      [actions]="tableActions"
      [selectable]="true"
    ></app-table>

  </div>


  <!-- ============================= -->
  <!-- TENURE -->
  <!-- ============================= -->
  <div class="bg-white rounded-xl shadow p-6">

    <h2 class="text-lg font-semibold text-indigo-900 mb-6">{{ 'CREDIT_TERMS.TENURE' | translate }}</h2>

    <app-dynamic-form
      [fields]="tenureFields">
    </app-dynamic-form>

  </div>


  <!-- ============================= -->
  <!-- REPAYMENTS -->
  <!-- ============================= -->
  <div class="bg-white rounded-xl shadow p-6">

    <h2 class="text-lg font-semibold text-indigo-900 mb-6">{{ 'CREDIT_TERMS.REPAYMENTS' | translate }}</h2>

    <app-dynamic-form
      [fields]="repaymentFields">
    </app-dynamic-form>

    <p class="text-xs text-gray-500 mt-4 italic">
      {{ 'CREDIT_TERMS.CURRENT_KIBOR_RATE' | translate: { rate: '11.25' } }}
    </p>

  </div>
<div class=" rounded-xl space-y-8">

  <h2 class="text-lg font-semibold text-indigo-900">
    {{ 'CREDIT_TERMS.PRICING_AND_CHARGES' | translate }}
  </h2>
<div>

  <div class="flex justify-between items-center mb-4">
    <h3 class="text-sm font-semibold text-indigo-900">{{ 'CREDIT_TERMS.MARKUP_RATE' | translate }}</h3>

    <button
      (click)="onAddMarkup()"
      class="bg-indigo-600 text-white px-4 py-2 rounded-lg"
    >
      {{ 'CREDIT_TERMS.ADD_NEW' | translate }}
    </button>
  </div>

  <app-table
    [columns]="markupColumns"
    [data]="markupData"
    [actions]="tableActions"
    [selectable]="true">
  </app-table>

</div>
<div>

  <div class="flex justify-between items-center mb-4">
    <h3 class="text-sm font-semibold text-indigo-900">{{ 'CREDIT_TERMS.SECURITY' | translate }}</h3>

    <button
      (click)="onAddSecurity()"
      class="bg-indigo-600 text-white px-4 py-2 rounded-lg"
    >
      {{ 'CREDIT_TERMS.ADD_NEW' | translate }}
    </button>
  </div>

  <app-table
    [columns]="securityColumns"
    [data]="securityData"
    [actions]="tableActions"
    [selectable]="true">
  </app-table>

</div>
<div>

  <div class="flex justify-between items-center mb-4">
    <h3 class="text-sm font-semibold text-indigo-900">{{ 'CREDIT_TERMS.SECURITY' | translate }}</h3>

    <button
      (click)="onAddSecurity()"
      class="bg-indigo-600 text-white px-4 py-2 rounded-lg"
    >
      {{ 'CREDIT_TERMS.ADD_NEW' | translate }}
    </button>
  </div>

  <app-table
    [columns]="securityColumns"
    [data]="securityData"
    [actions]="tableActions"
    [selectable]="true">
  </app-table>

</div>
<div>

  <div class="flex justify-between items-center mb-4">
    <h3 class="text-sm font-semibold text-indigo-900">{{ 'CREDIT_TERMS.COVENANTS' | translate }}</h3>

    <button
      (click)="onAddCovenant()"
      class="bg-indigo-600 text-white px-4 py-2 rounded-lg"
    >
      {{ 'CREDIT_TERMS.ADD_NEW' | translate }}
    </button>
  </div>

  <app-table
    [columns]="covenantColumns"
    [data]="covenantData"
    [actions]="tableActions"
    [selectable]="true">
  </app-table>

</div>
</div>

</div>
